export default function GhostWrapper({ children }) {
  return <div className="z-20 flex flex-col items-center justify-center">{children}</div>;
}
